import { SoftwarePlansRecurringTypesEnum } from '@thinknet-gmbh/platform-common';

export const SUBSCRIBE_INFO_DEFAULT_VALUE = {
  softwarePlanId: '',
  customerNumber: 20,
  additionalFeatureIds: [],
  recurringType: SoftwarePlansRecurringTypesEnum.MONTHLY,
};
